import {useSearchParams} from "react-router";
import {useRef, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import ScheduleAttendanceInfoService from "../../../services/reports/schedule-attendance-info-service.js";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import PrintOptionsModal from "../../../components/print-options-modal/print-options-modal.jsx";

const printFields = [
    {
        title: "Solicitantes",
        options: [
            {
                key: "showRequesters",
                label: "Exibir solicitantes na impressão",
            },
        ],
    },
    {
        title: "Anexos",
        options: [
            {
                key: "showImages",
                label: "Exibir imagens na impressão",
            },
            {
                key: "attachFullSize",
                label: "Imprimir um anexo por folha",
                disabled: (options) => !options.showImages,
            },
        ],
    },
];

const initialPrintOptions = Object.fromEntries(
    printFields.flatMap((group) =>
        group.options.map((item) => [item.key, false])
    )
);

export default function ScheduleAttendanceInfo() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const [printModal, setPrintModal] = useState(false);
    const [printOptions, setPrintOptions] = useState(initialPrintOptions);
    const printComponentRef = useRef(null);
    const title = "Informações do Agendamento";

    const { data: reportSchedule, isLoading: isLoadingReport } = useQuery({
        queryKey: ['schedule-attendance-info', id],
        queryFn: () => ScheduleAttendanceInfoService.getSchedule(id),
        enabled: !!id,
    });

    const hasData = !!reportSchedule?.schedule?.id;

    return (
        <>
            <Template isLoading={isLoadingReport || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printOptions={true}
                        printable={true}
                        setPrintModal={setPrintModal}
                        printComponentRef={printComponentRef}
                        reportData={reportSchedule}
                        data={hasData}
                        headerChange={true}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            {!isLoadingReport && !hasData && (
                                <div id="dataNotFound" className="alert alert-info p-2 h6 text-center">
                                    Nenhum registro encontrado.
                                </div>
                            )}

                            <Content
                                id={id}
                                reportData={reportSchedule}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                                printOptions={printOptions}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printFields}
            />
        </>
    )
}
